import { api } from '@/lib/api-client'
import type { CustomerPenalty, PageResponse, PenaltyFilters, WaivePenaltyRequest } from '@/types/api'

/**
 * The penalty ledger.
 *
 * As with refunds, there is deliberately no delete and no update: these rows
 * are financial records. A penalty leaves a customer's balance by being settled
 * — which the payment path does, not the dashboard — or waived, which is the
 * one write here.
 */
export function fetchPenalties(filters: PenaltyFilters): Promise<PageResponse<CustomerPenalty>> {
  return api.get<PageResponse<CustomerPenalty>>('/api/admin/penalties', { query: { ...filters } })
}

export function fetchPenalty(id: number): Promise<CustomerPenalty> {
  return api.get<CustomerPenalty>(`/api/admin/penalties/${id}`)
}

/** Every penalty ever charged to one customer, newest first. */
export function fetchPenaltiesForCustomer(userId: number): Promise<CustomerPenalty[]> {
  return api.get<CustomerPenalty[]>(`/api/admin/penalties/customer/${userId}`)
}

/**
 * Forgives one penalty.
 *
 * The acting administrator is not sent: the server takes it from the JWT, so a
 * browser cannot attribute the decision to a colleague.
 */
export function waivePenalty(id: number, body: WaivePenaltyRequest): Promise<CustomerPenalty> {
  return api.post<CustomerPenalty>(`/api/admin/penalties/${id}/waive`, body)
}
